import React, { useState, useEffect, useRef } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

function Header({ onToggleSidebar, sidebarOpen }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const profileMenuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        profileMenuRef.current &&
        !profileMenuRef.current.contains(event.target)
      ) {
        setShowProfileMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getInitials = (name) => {
    if (!name) return "U";
    return name
      .trim()
      .split(/\s+/)
      .map((part) => part[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Good morning";
    if (hour < 17) return "Good afternoon";
    return "Good evening";
  };

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <header className="topbar">
      <div className="topbar-left">
        <button
          className="menu-toggle"
          onClick={onToggleSidebar}
          aria-label={sidebarOpen ? "Close sidebar" : "Open sidebar"}
        >
          <i className={`fas fa-${sidebarOpen ? "times" : "bars"}`} />
        </button>

        {/* GREETING - NEW */}
        <div className="topbar-greeting">
          <span className="greeting-text">{getGreeting()},</span>
          <span className="greeting-name">{user?.fullName || "User"}</span>
          <span className="greeting-subtitle">
            Submit dealership leads and track them from intake to close.
          </span>
        </div>
      </div>

      <div className="topbar-right">
        <button className="topbar-add" onClick={() => navigate("/leads/add")}>
          <i className="fas fa-plus" />
          <span>New Lead</span>
        </button>

        <div className="user-profile-wrapper" ref={profileMenuRef}>
          <button
            className="user-profile"
            onClick={() => setShowProfileMenu(!showProfileMenu)}
            aria-expanded={showProfileMenu}
          >
            <span className="user-avatar">{getInitials(user?.fullName)}</span>
            <span className="user-profile-text">
              <strong>{user?.fullName || "User"}</strong>
              <small>{user?.role || "SR"}</small>
            </span>
            <i
              className={`fas fa-chevron-${showProfileMenu ? "up" : "down"}`}
            />
          </button>

          {showProfileMenu && (
            <div className="profile-dropdown">
              <div className="profile-dropdown-head">
                <span className="user-avatar large">
                  {getInitials(user?.fullName)}
                </span>
                <div>
                  <strong>{user?.fullName || "User"}</strong>
                  <small>{user?.email || ""}</small>
                </div>
              </div>
              <div className="dropdown-divider" />
              <button
                className="dropdown-item"
                type="button"
                onClick={handleLogout}
              >
                <i className="fas fa-sign-out-alt" />
                <span>Logout</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
